import { ref } from 'vue'

export const tester = ref()
export const testRun = ref()
export const testCasesSource = ref()
export const parsedTestCases = ref()
export const loadedTestCases = ref()
export const selectedCombinationIds = ref()
